export const BRAND = {
  name: "GN Agro Traders",
  legal: "A brand of Grewal & Namburu Agro Traders LLP",
  tagline: "Pure Grains. Global Standards.",
  phone: "+91 96631 04088",
  phoneTel: "+919663104088",
  phone2: "+91 70229 41901",
  phone2Tel: "+917022941901",
  email: "gnagrotraders@gmail.com",
  website: "https://gnagrotraders.com",
  logo: "https://customer-assets-eiarnc6j.emergentagent.net/job_f98d7288-1632-468a-8fb1-39c646f0fce3/artifacts/47pbxm53_Gemini_Generated_Image_95uowx95uowx95uo.png",
  whatsappBase: "https://wa.me/919663104088",
};

export const wa = (msg = "Hello GN Agro Traders, I am interested in your agricultural products and would like to discuss specifications, pricing, MOQ and export requirements.") =>
  `${BRAND.whatsappBase}?text=${encodeURIComponent(msg)}`;
